<div>
    <h2 mat-dialog-title> Adiciona permissão</h2>
    <mat-dialog-content>
        <div class="align-items-center justify-content-center">
            <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>Usuario</mat-label>
                <input type="text" placeholder="Pick one" aria-label="Number" matInput formControlName="form.get('usuario')" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let usuario of filteredOptions | async" [value]="usuario">
                        {{usuario.nome}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <button type="button" mat-raised-button (click)="salvar()" [disabled]='!form.valid' color="primary">Adicionar</button>
        </div>

        <div *ngIf="listaUsuariosPermitidos.length == 0" style="min-height: 80px" class="d-flex align-items-center justify-content-center">
            <span>Nenhum registro para o filtro especificado.</span>
        </div>

        <mat-card-content *ngIf="listaUsuariosPermitidos.length > 0">

            <table id="relatorios" mat-table [dataSource]="listaUsuariosPermitidos" class="table">
                <tbody>
                    <ng-container matColumnDef="nome">
                        <th mat-header-cell *matHeaderCellDef>Nome</th>
                        <td mat-cell *matCellDef="let p">{{ p?.usuarioOutput?.nome }}</td>
                    </ng-container>

                    <ng-container matColumnDef="usuario">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Usuario</th>
                        <td mat-cell *matCellDef="let p">{{ p?.usuario }}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Ações</th>
                        <td mat-cell *matCellDef="let p" width="100px">
                            <button mat-icon-button (click)="deletaPermissao(p.id)" aria-label="Example icon-button with a menu">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </tbody>
            </table>
        </mat-card-content>
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions>
        <div style="display: flex;">
            <button type="button" mat-raised-button color="warn" (click)="dialog.close()">Fechar</button>
        </div>
    </mat-dialog-actions>
</div>